import { CheckCircle, Swords } from 'lucide-react';
import { cn } from '@/helpers/utils';

export type NotificationEmptyVariant = 'empty' | 'all-read' | 'end-of-feed';

export type NotificationEmptyStateProps = {
  variant: NotificationEmptyVariant;
  className?: string;
};

export function NotificationEmptyState({ variant, className }: NotificationEmptyStateProps) {
  if (variant === 'empty') {
    return (
      <div className={cn('flex flex-col items-center justify-center gap-2 px-4 py-10 text-center', className)}>
        <Swords className="h-10 w-10 text-muted-foreground/60" aria-hidden />
        <p className="text-sm font-medium text-foreground">No notifications yet</p>
        <p className="text-xs text-muted-foreground">New duels and updates will appear here.</p>
      </div>
    );
  }

  return (
    <div className={cn('flex flex-col items-center justify-center gap-2 px-4 py-6 text-center', className)}>
      <CheckCircle className="h-8 w-8 text-muted-foreground/70" aria-hidden />
      <p className="text-sm font-medium text-foreground">You&apos;re all caught up!</p>
    </div>
  );
}
